module.exports = __webpack_public_path__ + "img/gc_country_flag_in.24b30694.svg";